<wsd-extended-card
  [loading]="!(constitutionInformation$ | async)"
  [redirectTo]="['/organizations', organizationId, 'modify', 'constitution']"
  [title]="'DATA_PORTAL.CONSTITUTION.TITLE' | translate">

  <div class="text-center" *ngIf=" constitutionInformation$ | async as data ">
    <div class="const-icon">
      <i class="fa fa-book-alt primary-color">
        <span></span>
        <i class="fa fa-balance-scale primary-color"></i>
      </i>
    </div>
    <div>
      <div [ngSwitch]="data.constitutionReceived">
        <div *ngSwitchCase="true">
          <div [ngSwitch]="!!data.lastYearOfApproval">
            <div *ngSwitchCase="true">
              <i class="fa fa-check fa-lg text-success"></i> {{ 'DATA_PORTAL.CONSTITUTION.APPROVED_IN' | translate:{year: data.lastYearOfApproval} }}
            </div>
            <div *ngSwitchDefault>
              <i class="fa fa-flag fa-lg text-success"></i> {{ 'DATA_PORTAL.CONSTITUTION.DELIVERED' | translate }}
            </div>
          </div>
        </div>
        <div *ngSwitchDefault>
          <i class="fa fa-flag fa-lg text-danger"></i> {{ 'DATA_PORTAL.CONSTITUTION.NOT_DELIVERED' | translate }}
        </div>
      </div>
    </div>
  </div>

</wsd-extended-card>
